<template>
    <div class="xcard" style="margin-bottom:16px">
        <p class="text-primary"> <b> <span class="text-danger">**</span> Cargos y sedes de este usuario::</b> </p>
        <small> Recuerde que el usuario debe estar activo para poder modificar los cargos. </small>
        <div class="row">
            <div class="col-sm-6">
                <multiselect class="form-control" v-model="modelo.idsede" :options="sedes" track-by="id" label="nombre" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Seleccione la sede..."></multiselect>
            </div>
            <div class="col-sm-5">
                <multiselect class="form-control" v-model="modelo.idcargo" :options="cargos" track-by="id" label="nombre" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="Seleccione el cargo..."></multiselect>
            </div>
            <div class="col">
                <button @click="asignar" type="button" class="btn btn-sm btn-azul white--text" :disabled="asignando">Asignar Cargos y Sedes</button>
            </div>
        </div>
        <multiselect :disabled="quitando" class="form-control" v-model="asignados" :options="asignados" track-by="idsede" label="nombre" 
            :multiple="true" :searchable="false" :close-on-select="true" :show-labels="false"
            @remove="onRemove" 
            placeholder="Cargos y sedes asignados.">
        
            <template slot="tag" slot-scope="{ option, remove }">
                <div>
                <span class="custom__tag">
                    <span class="custom__remove" @click="remove(option)">❌</span>
                    <span> {{option.nombre}} </span>
                </span>
                </div>
            </template>
        
        </multiselect>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import {parseJsonError,exito2,error2} from '@/components/Utils.js'
export default {
    props:{ model:Array,default:{type:Array,required:false,default:null},toasig:{type:Object,required:false} },
    data(){
        return{
            asignando: false,
            quitando: false,
            sedes: [],
            cargos: [],
            asignados: [],
            asig: {},
            modelo: {
                idsede: null,
                idcargo: null,
            } 
        }
    },
    watch:{
        'default': function(a){
            if( a == null ) return;
            var vue = this;
            a.forEach(function(e){
                vue.modelo = e;
                vue.cargar();
            });
            this.modelo.idsede = null;
            this.modelo.idcargo = null;
        },
    },
    methods:{
        async getSedes() {
            let rolid = this.$store.state.CARGO.id;
            if(rolid != 1){
                let d = this.$store.state.CARGOS;
                const sedes = [];
                d.forEach(x=>{
                    sedes.push({id:x.sede.id, nombre:x.sede.nombre,unidad_negocio:x.sede.unidad_negocio})
                })
                this.sedes = sedes;
                return;
            }

            var vue = this;
            var sql = gql`query{getSedes{id,nombre,unidad_negocio}}`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                var dat = data.data.getSedes;
                var jerarquia = this.$store.state.CARGO.id;
                if( jerarquia != 1 ){
                    var thiz = this;
                    dat = dat.filter( function(e){
                        var permitido = thiz.$store.state.CARGOS.find( x => x.idsede == e.id ); // mostrar solo las sedes permitidas
                        return permitido != null;
                    });
                }
                
                vue.sedes = dat;
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getSedes' ) )
            })
        },
        async getCargos() {
            var vue = this;
            var sql = gql`query{getCargos{id,nombre}}`;
            await this.$apollo.query({
            query: sql,
            }).then((data) => {
                var dat = data.data.getCargos;
                var jerarquia = this.$store.state.CARGO.id;
                var mkt = jerarquia == 11 || jerarquia == 11 || jerarquia == 11 ;
                // window.console.log( dat )
                if( jerarquia != 1 ){
                    dat = dat.filter(function(e){ 
                        if( mkt ){
                            return (e.nombre!="Master" && (e.id >= jerarquia && e.id <=13)) 
                        }else{
                            return (e.nombre!="Master")    
                        }
                    })
                }
                if(jerarquia != 1 ){
                    dat = dat.filter(function(e){return e.id != 14 })
                }
                
                vue.cargos = dat;
            }).catch((error) => {
                window.console.error(error)
                this.$notify( parseJsonError( error,'getCargos' ) )
            })
        },
        onRemove( removedOption ){
            var xu = sessionStorage.xxusuario;
            if( xu == null ) return;
            var iduser = JSON.parse(xu).id;
            var input = {};
            input.idusuario = iduser;
            input.idcargo = removedOption.idcargo;
            input.idsede = removedOption.idsede;
            input.desde = removedOption.desde;
            this.deleteCargo( input );
        },
        cargar(){
        window.console.log('cargarrrr', this.asignados, this.default);
        
            if( this.modelo.idsede != null && this.modelo.idcargo != null ){
                var existe = this.asignados.find(x => (x.idsede==this.modelo.idsede.id && x.idcargo==this.modelo.idcargo.id) );
                if( !existe ) {
                    var nom = this.modelo.idsede.nombre + ' - '+this.modelo.idcargo.nombre;
                    this.asignados.push( {idcargo:this.modelo.idcargo.id,idsede:this.modelo.idsede.id,nombre:nom,desde:this.modelo.desde} );
                }
            }

            if( this.default ){
                this.default.forEach(x=>{
                    const nom = x.idsede.nombre + ' - '+x.idcargo.nombre;
                    this.asignados.push( {idcargo:x.idcargo.id,idsede:x.idsede.id,nombre:nom,desde:x.desde} );
                })
            }
        },
        asignar(){
            if( this.modelo.idsede != null && this.modelo.idcargo != null ){
                //var existe = this.asignados.find(x => (x.idsede==this.modelo.idsede.id && x.idcargo==this.modelo.idcargo.id) );
                var existe = this.asignados.find(x => (x.idsede==this.modelo.idsede.id ) ); // no mas de un cargo por sede
                if( !existe ) {
                    this.asignando = true;
                    window.console.log( "ASIGNARRR ",this.modelo );
                    this.agregarCargo( this.modelo );
                }else{
                    this.$notify( error2( 'No Valido','No se permite mas de un cargo por sede.',4000 ) )
                }
            }else{
                this.$notify( error2( 'Seleccione','Falta sede y cargo',2000 ) )
            }
        },
        async deleteCargo( input ){
            var vue = this;
            vue.quitando = true;
            var sql = gql`mutation{ deshabilitarCargoUsuarioSede(input:${window.stringifyObject(input)}){ok,errors{message}} }`;
            window.console.log( "DESHABILITANDO::::",sql,input ); 
            await this.$apollo.mutate({
                mutation: sql,
            }).then((data) => {
                var ok = data.data.deshabilitarCargoUsuarioSede.ok;
                if( ok ) {
                    vue.$notify( exito2( 'Eliminado','Cargo eliminado.',2000 ) )
                    vue.quitando = false;
                }

            }).catch((error) => {
                window.console.error(error)
                vue.$notify( parseJsonError( error,'deshabilitarCargoUsuarioSede' ) )
                vue.quitando = false;
            })
        },
        async agregarCargo( modelo ){
            var vue = this;
            var xu = sessionStorage.xxusuario; 
            if( xu == null ) return;
            var iduser = JSON.parse(xu).id;
            var input = {};
            input.idusuario = iduser;
            input.cargos = [ { idcargo:modelo.idcargo.id ,idsede:modelo.idsede.id } ];
            if( this.toasig ){
                window.sessionStorage.setItem( 'CARGOS_ASIG',JSON.stringify(input.cargos) )
                this.toasig.asignados = input.cargos;
            }

            var sql = gql`mutation{ registrarCargoUsuarioSede(input:${window.stringifyObject(input)}){ok,errors{message}} }`;
            window.console.log( "AGRREGANDO:::: ",sql,input ); 
            await this.$apollo.mutate({
                mutation: sql,
            }).then((data) => {
                var ok = data.data.registrarCargoUsuarioSede.ok;
                window.console.log( "DATA ",data )
                if( ok ) {
                    vue.$notify( exito2( 'Registrado','Cargo Registrado.',2000 ) )
                    var nom = modelo.idsede.nombre + ' - '+modelo.idcargo.nombre;
                    this.asignados.push( {idcargo:modelo.idcargo.id,idsede:modelo.idsede.id,nombre:nom,desde:modelo.desde} );
                }else{
                    var errores = JSON.stringify(data.data.registrarCargoUsuarioSede.errors);
                    var obj = JSON.parse( errores );
                    var vals = '';
                    obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
                    this.$notify( error2( 'No Valido','Del Servidor: '+vals,4000 ) )
                }
                this.asignando = false;

            }).catch((error) => {
                window.console.error(error)
                vue.$notify( parseJsonError( error,'registrarCargoUsuarioSede' ) )
                vue.asignando = false;
            })
        }
    },
    mounted(){
        this.getSedes();
        this.getCargos();
    }
}
</script>